import { render } from "./EditAchievements.vue?vue&type=template&id=4d3d2351"
import script from "./EditAchievements.vue?vue&type=script&lang=js"
export * from "./EditAchievements.vue?vue&type=script&lang=js"

import "./EditAchievements.vue?vue&type=style&index=0&id=4d3d2351&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__